import { Star } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";

export const TrustBar = () => {
  const ref = useReveal();
  return (
    <section ref={ref} data-testid="trust-bar" className="py-14 border-b" style={{ background: "var(--paper)", borderColor: "var(--grey-3)" }}>
      <div className="pw-container flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="reveal flex items-center gap-5">
          <div className="flex gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={18} fill="var(--accent)" stroke="none" />
            ))}
          </div>
          <p className="text-[15px] font-medium" style={{ color: "var(--ink-3)" }}>
            Более 20 лет работаем с итальянской верхней одеждой
          </p>
        </div>
        <div className="reveal flex items-baseline gap-3">
          <span className="font-semibold" style={{ fontSize: "clamp(2rem, 3.4vw, 3rem)", letterSpacing: "-0.04em" }}>
            20+
          </span>
          <span className="text-[13px] font-medium uppercase tracking-[0.14em]" style={{ color: "var(--grey-2)" }}>
            лет опыта
          </span>
        </div>
      </div>
    </section>
  );
};
